
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.697","height":"24.697","viewBox":"0 0 24.697 24.697"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_2","data-name":"Group 2","transform":"translate(-196.317 -132.935)"}},[_c('circle',{attrs:{"id":"Ellipse_2","data-name":"Ellipse 2","cx":"12.348","cy":"12.348","r":"12.348","transform":"translate(196.317 132.935)","fill":"#fff"}}),_c('path',{attrs:{"id":"Path_2","data-name":"Path 2","d":"M215.277,143.488a2.966,2.966,0,0,0-2.966-2.965h-7.582a2.966,2.966,0,0,0-2.965,2.965v3.529a2.966,2.966,0,0,0,2.965,2.965h7.582a2.966,2.966,0,0,0,2.966-2.965Zm-4.459,2.029-3.4,1.682c-.134.072-.587-.025-.587-.176V143.57c0-.154.457-.25.59-.174l3.255,1.771C210.812,145.245,210.956,145.442,210.818,145.517Z","fill":"#fd7e14"}})])])
          )
        }
      }
    